import { render, staticRenderFns } from "./BatchesReject.vue?vue&type=template&id=cbb1cf00&"
import script from "./BatchesReject.vue?vue&type=script&lang=js&"
export * from "./BatchesReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbb1cf00')) {
      api.createRecord('cbb1cf00', component.options)
    } else {
      api.reload('cbb1cf00', component.options)
    }
    module.hot.accept("./BatchesReject.vue?vue&type=template&id=cbb1cf00&", function () {
      api.rerender('cbb1cf00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/batches/views/components/modals/BatchesReject.vue"
export default component.exports